"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "56", height: "56", viewBox: "0 0 56 56", className: "Icon payment-free", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M11.004 30.794c0 .429.34.769.782.769.428 0 .768-.34.768-.769V27.91h3.805a.704.704 0 1 0 0-1.411h-3.805V24.09h4.372a.704.704 0 1 0 0-1.411h-5.14a.77.77 0 0 0-.782.781v7.333zm8.266 0c0 .429.34.769.781.769.429 0 .769-.34.769-.769v-2.368h1.953l2.142 2.734c.176.24.403.403.756.403.378 0 .743-.29.743-.718 0-.24-.1-.403-.252-.592l-1.688-2.13c1.184-.365 2.003-1.222 2.003-2.633v-.025c0-.769-.265-1.424-.73-1.903-.568-.554-1.437-.882-2.546-.882h-3.15a.77.77 0 0 0-.781.781v7.333zm1.55-3.742v-2.96h2.255c1.147 0 1.827.516 1.827 1.46v.026c0 .895-.706 1.474-1.814 1.474H20.82zm8.34 4.448h5.192a.691.691 0 0 0 .693-.693.7.7 0 0 0-.693-.693H29.93v-2.369h3.792a.688.688 0 0 0 .693-.68.702.702 0 0 0-.693-.706H29.93v-2.293h4.36a.691.691 0 0 0 .693-.693.7.7 0 0 0-.693-.693h-5.128a.77.77 0 0 0-.781.781v7.258c0 .44.34.781.78.781zm8.443 0h5.191a.691.691 0 0 0 .693-.693.7.7 0 0 0-.693-.693h-4.422v-2.369h3.792a.688.688 0 0 0 .693-.68.702.702 0 0 0-.693-.706h-3.793v-2.293h4.36a.691.691 0 0 0 .693-.693.7.7 0 0 0-.693-.693h-5.128a.77.77 0 0 0-.781.781v7.258c0 .44.34.781.78.781z", fill: "#F4511C" }),
            _react2.default.createElement("circle", { stroke: "#F4511C", cx: "27", cy: "27", r: "27", strokeWidth: "1.5" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/payment-free.js
// module id = 1821
// module chunks = 0